<template>
	<retailer-commission-dashboard :isRummyOptionSelected="true" />
</template>

<script>
import RetailerCommissionDashboard from "../CommissionDashboard/RetailerCommissionDashboard";
export default {
	components: {
		"retailer-commission-dashboard": RetailerCommissionDashboard
	}
};
</script>
